import { useState } from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import { FaBars } from 'react-icons/fa';
import { navLinkData } from '../../data/navLinkData';
import { Link as NavLink } from 'react-router-dom'
import { Link } from 'react-scroll';
import './Navbar.css';

function Navbar({ref}) {
	const [click, setClick] = useState(false);
	const handleClick = () => setClick(!click);

	return (
		<div className="navbar">
			<header>
				<div className="logo">
					<NavLink to="/">
						<img src="../../logo.png" alt="logo" />
						<h1>OkoaPatient</h1>
					</NavLink>
				</div>
				<nav className={click ? 'nav-options active' : 'nav-options'} id="navbar">
					<ul>
						{
							navLinkData.map((data, index) =>{
								return(
									<Link key={index} className='nav' to={data.id} spy={true} smooth={true}>
											{data.linkName}+
									</Link>
								)
							})
						}
						<NavLink to="/login" className='auth-link'>Get Started</NavLink>
					</ul>
				</nav>
				<div className="toggle mobile-menu" onClick={handleClick}>
					{click ? <AiOutlineClose className="menu-icon" /> : <FaBars className="menu-icon" />}
				</div>
			</header>
		</div>
	);
}

export default Navbar;
